import type { Language } from './context.js';

export const appCopy: Record<Language, {
  readonly loading: string;
  readonly controlTakenTitle: string;
  readonly controlTakenDescription: string;
  readonly returnToAccess: string;
  readonly closeError: string;
}> = {
  en: {
    loading: 'Connecting to the desk…',
    controlTakenTitle: 'Control moved elsewhere',
    controlTakenDescription: 'Another window now controls this pseudonym. No new order can be sent from this window.',
    returnToAccess: 'Return to access',
    closeError: 'Dismiss error'
  },
  fr: {
    loading: 'Connexion au desk…',
    controlTakenTitle: 'Contrôle repris ailleurs',
    controlTakenDescription: 'Une autre fenêtre contrôle maintenant ce pseudo. Aucun nouvel ordre ne peut être envoyé ici.',
    returnToAccess: 'Retour à l’accès',
    closeError: 'Fermer l’erreur'
  }
};
